import { BaseAPIModel } from '@weezevent/weezjs-core';

export class BusinessEntity extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl() {
        return `/ticket/accounting/business_entity`;
    }

    toOption() {
        return {
            text: this.name,
            value: this.uuid,
            key: this.uuid
        };
    }
}
